import dynamic from 'next/dynamic';
import { useSelector } from 'react-redux';
const SearchView = dynamic(() => import('../search/SearchView'));
const MobileSearchView = dynamic(() => import('../search/MobileSearchView'));

interface SearchProps {
  loadedSearchResultsSSR: any;
  pageTitle: string;
  launches: any;
}

const Search = ({
  loadedSearchResultsSSR,
  pageTitle,
  launches
}: SearchProps) => {
  

  const isMobile = useSelector((state: any) => state.app.isMobile);
  if (isMobile)
    return (
      <MobileSearchView
        loadedSearchResultsSSR={loadedSearchResultsSSR}
        pageTitle={pageTitle}
        launches={launches}
      />
    );
  else
    return (
      <SearchView
        loadedSearchResultsSSR={loadedSearchResultsSSR}
        pageTitle={pageTitle}
        launches={launches}
      />
    );
};

export default Search;
